import styled from 'styled-components'

import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'

import { colorVariant } from '.'

export const Wrapper = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;

    height: 40px;

    ${props => {
        const { outlined, type, disabled, loading, width } = props

        const border = outlined ? `1px solid ${colorVariant[type]}` : `none`
        const background = outlined ? `transparent` : colorVariant[type]
        const color = outlined ? colorVariant[type] : `#f2f2f2`
        const filter = disabled ? `grayscale(100%)` : `none`
        const cursor = disabled || loading ? `not-allowed` : `pointer`
        return `
            border: ${border};
            background: ${background};
            color: ${color};
            filter: ${filter};
            cursor: ${cursor};
            width: ${width || '156px'};
        `
    }}

    border-radius: 4px;
    outline: none;

    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(12, 16)};
    line-height: 20px;

    &:hover {
        opacity: 0.7;
    }

    ${applyIPadOnlyStyle(`width: 40vw`, {
        min: 0,
        max: 340,
        orientation: 'both',
    })}

    ${applyIPadOnlyStyle(`width: 80%`, {
        min: 0,
        max: 340,
        orientation: 'portrait',
    })}
`

export const Loader = styled.img`
    width: 15px;
    height: 15px;
    margin: 0 25px;
`
